import React from 'react';
import { ContentWrapper } from '../../utils/components';
import Gevel from '../../../assets/images/gevel.JPG';
import AutoFirst from '../../../assets/images/autofirst_1.png';
import Thomas from '../../../assets/images/team/thomas.jpg';
import Marieke from '../../../assets/images/team/marieke.jpg';
import Thias from '../../../assets/images/team/thias.jpg';

import '../../styles/About.css';

const teamleden = [
  {
    naam: 'Thomas',
    foto: Thomas,
    functie: 'Zaakvoerder',
  },
  {
    naam: 'Thias',
    foto: Thias,
    functie: 'Carrossier',
  },
  {
    naam: 'Marieke',
    foto: Marieke,
    functie: 'Administratief beheerder',
  },
  // Voeg hier meer teamleden toe als nodig
];

const About = () => (
  <div className="section about-wrapper">
    <ContentWrapper>
      <h2 className="title about-title">Over ons</h2>
      <div className="about-items-wrapper">
        <div className="team-section">
          <div className="team-grid">
            {teamleden.map((lid, index) => (
              <div className="team-member" key={index}>
                <img src={lid.foto} alt={lid.naam} className="team-foto" />
                <p className="team-naam"><span className="bold">{lid.naam}</span> - {lid.functie}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="about-row">
          <div className="about-item">
            <h6 className="about-subtitle">Auto-Service Thomas, sinds 2014</h6>
            <hr className="about-break" />
            <p className="about-text">
              Auto-Service Thomas is een eenmanszaak, opgericht in 2014 door Thomas Van Wassenhove.<br />
              Bij ons kunt u terecht voor diverse autoherstellingen, zowel elektrisch als mechanisch, evenals voor carrosserieschade.
              Daarnaast zijn wij gespecialiseerd in de restauratie van oldtimers.<br /><br />

              Onze garage is gevestigd op Gentweg 26 te 9940 Evergem, strategisch gelegen tussen het veer van Langerbrugge en Terdonk.<br /><br />

              Vlotte service, vriendelijke communicatie en kwaliteit staan bij ons centraal.
            </p>
          </div>
          <div className="about-item">
            <img src={Gevel} alt="Thomas Van Wassenhove" className="about-image" />
          </div>
        </div>
        <div className="about-row reverse">
          <div className="about-item">
            <h6 className="about-subtitle">Samenwerking AUTOFIRST - LKQ Belgium</h6>
            <hr className="about-break" />
            <p className="about-text">
              Dankzij een langdurige samenwerking met LKQ Belgium zijn wij onlangs een nieuwe samenwerking aangegaan met AutoFirst.
              Sindsdien mogen wij ons met trots een officiële AutoFirst-garage noemen.<br /><br />

              Door deze nauwe samenwerking met beide partners blijven wij steeds op de hoogte van de nieuwste ontwikkelingen en technologieën voor uw voertuig.
              Geen enkel voertuig heeft nog geheimen voor ons, waardoor wij u een service van de hoogste kwaliteit kunnen garanderen.
            </p>
          </div>
          <div className="about-item">
            <img src={AutoFirst} alt="AutoFirst samenwerking" className="about-image autoFirst" />
          </div>
        </div>
      </div>
    </ContentWrapper>
  </div>
);

export default About;